module.exports = __webpack_public_path__ + "media/images/payment-providers/visa-card-3c574e5fde7667737b137b3d1443fb75.svg";